type FailedLoginAttemp = {
  count: number;
  redirected: boolean;
  timestamp: number;
  username: string;
};

export const FAILED_LOGIN_ATTEMPTS_KEY = 'FailedLoginAttempts';

export function displayFailedLoginAttempts(
  increase: boolean,
  locked: boolean,
  setFailedLoginDialogOpen: (o: boolean) => void,
  failedLoginAttemptsLabel: string,
  failedLoginWarning: string
): void {
  let currentUsername = document.querySelector<HTMLInputElement>(
    '#okta-signin-username'
  )?.value;
  if (!currentUsername) {
    return;
  }
  currentUsername = currentUsername.trim().toLowerCase();

  const failedLoginAttempts = getFailedLoginAttemps();
  let failedLoginAttempt = failedLoginAttempts.find(
    (x) => x.username === currentUsername
  );
  if (failedLoginAttempt) {
    if (increase && failedLoginAttempt.count < 5) {
      failedLoginAttempt.timestamp = new Date().getTime();
      failedLoginAttempt.count++;
    }
  } else {
    if (!increase) {
      return;
    }
    failedLoginAttempt = {
      count: 1,
      redirected: false,
      timestamp: new Date().getTime(),
      username: currentUsername,
    };
    failedLoginAttempts.push(failedLoginAttempt);
  }

  const count = failedLoginAttempt.count;

  const parentDiv = document.querySelector<HTMLDivElement>('.o-form-content');
  let h2 = document.querySelector<HTMLHeadingElement>('#loginFailedCount');
  if (!h2) {
    h2 = document.createElement('h2');
    h2.classList.add('o-form-head');
    h2.setAttribute('id', 'loginFailedCount');
    h2.setAttribute('style', 'color: #e34843');
    parentDiv?.insertBefore(h2, parentDiv.children[0]);
  }
  h2.innerText = failedLoginAttemptsLabel
    .replace('{{0}}', String(count))
    .replace('{{1}}', '5');

  const parentDiv2 = document.querySelector<HTMLDivElement>(
    '.o-form-fieldset-container'
  );
  let div = document.querySelector<HTMLDivElement>('#loginFailedWarning');
  if (!div) {
    div = document.createElement('div');
    div.setAttribute('id', 'loginFailedWarning');
    div.setAttribute('style', 'color: #e34843; margin-top: -20px');
    parentDiv2?.appendChild(div);
  }
  const btnSignIn = document.querySelector<HTMLButtonElement>(
    '#okta-signin-submit'
  );
  if (btnSignIn) {
    btnSignIn.disabled = false;
  }

  if (currentUsername === 'sale99') {
    //TO DO: implement sale99 use case later
  } else if (count === 3 && !failedLoginAttempt.redirected) {
    setFailedLoginDialogOpen(true);
    failedLoginAttempt.redirected = true;
    setTimeout(function () {
      setFailedLoginDialogOpen(false);
      document
        .querySelector<HTMLAnchorElement>('a[data-se="forgot-password"]')
        ?.click();
    }, 5000);
  }

  if (count >= 2 && !locked) {
    div.innerHTML = failedLoginWarning.replace('{{0}}', String(count));
  } else {
    div.innerHTML = '';
  }

  if (locked || currentUsername === 'sale99') {
    hideForgotPasswordLink(true);
  } else {
    hideForgotPasswordLink(false);
  }

  const failedLoginAttemptsJson = JSON.stringify(failedLoginAttempts);
  localStorage.setItem(FAILED_LOGIN_ATTEMPTS_KEY, failedLoginAttemptsJson);
}

export function getUsernameFromLastFailedLoginAttempt(): string {
  const failedLoginAttempts = getFailedLoginAttemps();
  if (failedLoginAttempts.length > 0) {
    const lastLoginAttempt = failedLoginAttempts.reduce((prev, current) => {
      return prev.timestamp > current.timestamp ? prev : current;
    });
    return lastLoginAttempt.username;
  }
  return '';
}

export function clearFailedLoginAttempt() {
  document.querySelector<HTMLHeadingElement>('#loginFailedCount')?.remove();
  document.querySelector<HTMLDivElement>('#loginFailedWarning')?.remove();
  localStorage.removeItem(FAILED_LOGIN_ATTEMPTS_KEY);
}

export const getFailedLoginAttemps = () => {
  let failedLoginAttempts: FailedLoginAttemp[] = [];
  const failedLoginAttemptsJson = localStorage.getItem(
    FAILED_LOGIN_ATTEMPTS_KEY
  );
  if (failedLoginAttemptsJson) {
    try {
      failedLoginAttempts = JSON.parse(failedLoginAttemptsJson);
      failedLoginAttempts = failedLoginAttempts.filter(
        (x) => new Date().getTime() - x.timestamp < 1200000
      );
    } catch (err) {
      localStorage.removeItem(FAILED_LOGIN_ATTEMPTS_KEY);
    }
  }
  return failedLoginAttempts;
};

const hideForgotPasswordLink = (e: boolean) => {
  document
    .querySelector('a[data-se="forgot-password"]')
    ?.parentElement?.setAttribute(
      'style',
      e ? 'display: none' : 'display: block'
    );
};
